export default "__VITE_ASSET__BSNKmtrY__"